import React from 'react';

const DisqualifiedStep = ({ reason, onStartOver }) => {
  return (
    <div className="text-center py-8" data-testid="disqualified-step">
      {/* Icon */}
      <div className="w-20 h-20 mx-auto bg-orange-100 rounded-full flex items-center justify-center mb-6">
        <svg className="w-10 h-10 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>

      {/* Title */}
      <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-4">
        We&apos;re Sorry
      </h2>

      {/* Description */}
      <p className="text-gray-600 mb-6 max-w-md mx-auto">
        Based on your responses, you may not be a candidate for this treatment program at this time.
      </p>

      {/* Reason */}
      {reason && (
        <div className="bg-orange-50 rounded-xl p-4 mb-8 max-w-md mx-auto text-left">
          <p className="text-sm text-orange-800">
            <strong>Reason:</strong> {reason}
          </p>
        </div>
      )}

      {/* Recommendation */}
      <div className="bg-gray-50 rounded-xl p-6 max-w-md mx-auto text-left mb-8">
        <h3 className="font-semibold text-gray-900 mb-3">What you can do:</h3>
        <ul className="space-y-3">
          <li className="flex items-start gap-3">
            <div className="w-6 h-6 bg-[#2d8a5f] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-white text-xs font-bold">1</span>
            </div>
            <p className="text-sm text-gray-600">Consult with your primary care physician about your weight loss goals</p>
          </li>
          <li className="flex items-start gap-3">
            <div className="w-6 h-6 bg-[#2d8a5f] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-white text-xs font-bold">2</span>
            </div>
            <p className="text-sm text-gray-600">Discuss alternative treatment options that may be appropriate for your situation</p>
          </li>
          <li className="flex items-start gap-3">
            <div className="w-6 h-6 bg-[#2d8a5f] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-white text-xs font-bold">3</span>
            </div>
            <p className="text-sm text-gray-600">Contact our support team if you have questions about your eligibility</p>
          </li>
        </ul>
      </div>

      {/* Contact */}
      <p className="text-sm text-gray-500 mb-6">
        Have questions? Contact us at <a href="mailto:support@fitpal.com" className="text-[#2d8a5f] underline">support@fitpal.com</a>
      </p>

      {/* Button */}
      <button
        onClick={onStartOver}
        className="px-8 py-3 text-[#2d8a5f] font-medium hover:bg-gray-50 rounded-xl transition-colors border border-[#2d8a5f]"
        data-testid="start-over-button"
      >
        Start Over
      </button>
    </div>
  );
};

export default DisqualifiedStep;
